<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiTag } from "@mdi/js";
export default {
  name: "MdiTag",
  data() {
    return {
      svgPath: mdiTag,
    };
  },
};
</script>
